module.exports = __webpack_public_path__ + "static/media/card-icon-4.3d80c36c.svg";